module.exports = __webpack_public_path__ + "static/img/13.c00411d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/eng/13.png
// module id = TmPi
// module chunks = 0